import React, { FC } from 'react';
import MuiCollapse, { CollapseProps as MuiCollapseProps } from '@mui/material/Collapse';
import { BpDesignSystem } from '../../types';

export type CollapseProps = BpDesignSystem.PropsWithChildren<MuiCollapseProps & {}>;

export const Collapse: FC<CollapseProps> = ({ dataTest, ...props }) => <MuiCollapse data-test={dataTest} {...props} />;
